var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.632 7.028A3.837 3.837 0 1 1 5.368.647a3.837 3.837 0 0 1 4.264 6.38ZM15 16.136H0a7.45 7.45 0 0 1 2.197-5.303A7.5 7.5 0 0 1 15 16.136Z",
  fill: "#C5CADA"
})));
export { SvgUserIcon as ReactComponent };
export default __webpack_public_path__ + "2e940f472b90ed393bc4efaeca98e300.svg";